import React from "react";

/**
 * Tiny SVG sparkline — no external library. `data` is an array of
 * `{ date, value }` objects (or numbers). Fixed-height, 100% width.
 */
export function MiniSparkline({ data = [], height = 40, color, "data-testid": testId }) {
  const vals = data.map((d) => (typeof d === "number" ? d : Number(d.value) || 0));
  if (vals.length < 2) {
    return (
      <div
        className="text-[10px] font-mono text-[color:var(--muted)] italic"
        style={{ height }}
        data-testid={testId}
      >
        — not enough data
      </div>
    );
  }
  const max = Math.max(...vals, 1);
  const min = Math.min(...vals, 0);
  const span = max - min || 1;
  const W = 100;
  const H = 100;
  const step = W / (vals.length - 1);
  const points = vals.map((v, i) => {
    const x = i * step;
    const y = H - ((v - min) / span) * H;
    return `${x.toFixed(2)},${y.toFixed(2)}`;
  }).join(" ");
  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      style={{ width: "100%", height, display: "block" }}
      data-testid={testId}
    >
      <polyline
        fill="none"
        stroke={color || "var(--cobalt)"}
        strokeWidth="1.5"
        points={points}
      />
    </svg>
  );
}
